import React, { useState, useEffect } from 'react'

export const Session = React.createContext()

export function SessionProvider (props) {
  const [positionInfo, setPositionInfo] = useState({}) // 根据床位号获取的床位信息
  const [patientInfo, setPatientInfo] = useState([]) // 根据床位号（床头二维码）获得的病员信息(url中的床位号)
  const [patientInfoByWristband, setPatientInfoByWristband] = useState({}) // 根据微信扫一扫获得的病员信息
  const [positionInfoByWristband, setPositionInfoByWristband] = useState({}) // 根据微信扫一扫获得的病员床位信息
  const [currentUser, setCurrentUser] = useState({}) // 根据token获取的用户信息，可能有病员信息
  const [logged, setLogged] = useState(true) // 用户是否已经有账号
  const [binded, setBinded] = useState(true) // 用户是否绑定病员
  const [codeExist, setCodeExist] = useState(false)
  const [tokenExist, setTokenExist] = useState(window.localStorage.getItem('sdxUserToken') && window.localStorage.getItem('sdxUserToken').length > 0)

  useEffect(() => {
    if (currentUser.patientDTO && JSON.stringify(currentUser.patientDTO) !== '{}') {
      setBinded(true)
    } else {
      setBinded(false)
    }
  }, [currentUser.patientDTO])

  useEffect(() => {
    setLogged(tokenExist)
  }, [tokenExist])

  return (
    <Session.Provider
      value={{
        currentUser: currentUser,
        setCurrentUser: setCurrentUser,
        patientInfo: patientInfo,
        setPatientInfo: setPatientInfo,
        patientInfoByWristband: patientInfoByWristband,
        positionInfoByWristband: positionInfoByWristband,
        setPositionInfoByWristband: setPositionInfoByWristband,
        setPatientInfoByWristband: setPatientInfoByWristband,
        positionInfo: positionInfo,
        setPositionInfo: setPositionInfo,
        logged: logged,
        setLogged: setLogged,
        binded: binded,
        setBinded: setBinded,
        codeExist: codeExist,
        setCodeExist: setCodeExist,
        tokenExist: tokenExist,
        setTokenExist: setTokenExist
      }}
    >
      {props.children}
    </Session.Provider>
  )
}
